module.exports = __webpack_public_path__ + "static/media/mouthStretchLeft.40f1910c.obj";